export enum AccountTabs {
  OVERVIEW = 'overview',
  CREATIONS = 'creations',
  ASSETS = 'assets',
  REFERRAL = 'referral'
}
